import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';

function CardSkeleton() {
    return (
        <Column fullWidth aria-busy>
            <CardArea>
                <Skeleton shape='block' height='auto' style={{ aspectRatio: '3 / 2' }} />
            </CardArea>
            <Detail fullWidth spacing={5} align='center'>
                <Column align='center' spacing={1}>
                    <Skeleton width={120} height={22} />
                    <Skeleton width={160} height={31} />
                </Column>
                <Row fullWidth spacing={2}>
                    <Skeleton shape='block' width='calc(50% - 4px)' height={56} />
                    <Skeleton shape='block' width='calc(50% - 4px)' height={56} />
                </Row>
            </Detail>
        </Column>
    );
}

const CardArea = styled.div`
    padding: 16px;
    width: 100%;
`;

const Detail = styled(Column)`
    padding: 8px 16px 16px;
`;

export default CardSkeleton;
